var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "user-tooltip",
      on: {
        click: function ($event) {
          return _vm.openHelpPopUp("data.html")
        },
      },
    },
    [
      _c("img", {
        attrs: {
          src: _vm.userCommonImageUrlForPc + "/tooltip_help_pc.png",
          alt: "データの説明",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }